// 募集職種の列挙型
export enum JobType {
  SALES = '営業',
  LEASING = '賃貸仲介',
  SALES_BROKERAGE = '売買仲介',
  PROPERTY_MANAGEMENT = '管理',
  DEVELOPMENT = '開発企画',
  MARKETING = 'マーケティング',
  BACK_OFFICE = '事務・バックオフィス',
  IT_SYSTEMS = 'IT・システム',
  OTHER = 'その他',
}

// 要件定義準拠：シンプルな公開・非公開制御（enumは削除）

// 企業基本情報
export interface CompanyBasicInfo {
  id: number;
  name: string;
  business_type: string;
  prefecture: string;
  city: string;
  employee_count_range: string;
  logo_url?: string;
}

// 企業プロフィール情報（要件定義準拠）
export interface CompanyProfile {
  business_content?: string;
  recruiting_message?: string;
  job_types?: JobType[];
  target_candidates?: string;
  company_images?: string[];
  logo_url?: string;
  is_published: boolean; // 要件定義準拠：シンプルな公開・非公開制御
  view_count: number;
  last_updated: string;
}

// 権限情報
export interface CompanyProfilePermissions {
  can_edit: boolean;
  can_view_analytics: boolean;
}

// 企業プロフィール取得レスポンス
export interface CompanyProfileResponse {
  success: true;
  data: {
    company: CompanyBasicInfo;
    profile: CompanyProfile;
    permissions: CompanyProfilePermissions;
  };
}

// 企業プロフィール更新リクエスト（要件定義準拠）
export interface UpdateCompanyProfileRequest {
  business_content?: string;
  recruiting_message?: string;
  job_types?: JobType[];
  target_candidates?: string;
  company_images?: string[];
  is_published: boolean; // 要件定義準拠：シンプルな公開・非公開制御
  logo_url?: string;
  employee_count_range?: string;
}

// 企業プロフィール更新レスポンス
export interface UpdateCompanyProfileResponse {
  success: true;
  data: {
    updated: boolean;
    message: string;
  };
}

// フォームデータ型（要件定義準拠）
export interface CompanyProfileFormData {
  business_content?: string;
  recruiting_message?: string;
  job_types?: JobType[];
  target_candidates?: string;
  company_images?: string[];
  is_published: boolean; // 要件定義準拠：シンプルな公開・非公開制御
  logo_url?: string;
  employee_count_range?: string;
}

// バリデーションエラー型（要件定義準拠）
export interface ValidationErrors {
  business_content?: string;
  recruiting_message?: string;
  job_types?: string;
  target_candidates?: string;
  company_images?: string;
  is_published?: string; // 要件定義準拠：シンプルな公開・非公開制御
  logo_url?: string;
  employee_count_range?: string;
}

// 企業プロフィール画像アップロードレスポンス
export interface CompanyProfileImageUploadResponse {
  success: true;
  data: {
    image_url: string;
    file_size: number;
    file_name: string;
    message: string;
  };
}

// 企業ロゴアップロードレスポンス
export interface CompanyLogoUploadResponse {
  success: true;
  data: {
    logo_url: string;
    file_size: number;
    file_name: string;
  };
  message: string;
}
